var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUcLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 38,
    viewBox: "0 0 145 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_17130_11021)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17130_11021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.046 34.0247H3.01123V1.98999H35.046V34.0247Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0968 14.3583C19.5325 13.4297 17.182 13.5654 15.6757 15.4442C14.2307 17.2468 14.5485 19.5145 15.7486 20.8421C17.5313 18.6803 19.314 16.5185 21.0968 14.3583Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6065 15.8101C20.88 17.9007 19.1585 19.988 17.437 22.077C18.7596 22.6497 20.9297 22.5272 22.3284 20.8239C23.6957 19.1521 23.4921 17.0797 22.6065 15.8101Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6193 9.16229C21.2047 14.5155 16.8298 19.819 12.4482 25.1325C13.0474 25.6539 13.65 26.1439 14.3601 26.5147C18.6721 21.2873 22.9841 16.0566 27.3144 10.806C27.4104 10.9119 27.4981 11.0046 27.5792 11.1039C28.9316 12.7774 29.7956 14.6694 30.039 16.813C30.3617 19.68 29.6268 22.2755 27.8954 24.5846C26.3775 26.614 24.4027 28.0077 21.9545 28.6732C17.5548 29.8683 13.0574 28.3272 10.2351 24.674C7.38637 20.991 7.26057 16.285 9.51838 12.5209C11.316 9.5248 13.9595 7.67916 17.4141 7.09484C19.7265 6.70088 21.9396 7.10974 24.0088 8.21547C24.5484 8.50018 25.0632 8.83124 25.6193 9.16229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7438 9.56625C19.7066 14.4593 15.671 19.3523 11.6338 24.2453C8.91744 21.2377 8.19574 16.103 11.4682 12.026C14.8798 7.77192 20.2032 7.46238 23.7438 9.56625Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1621 12.8521C29.1649 15.7273 29.6284 20.4217 26.5264 24.2007C23.3615 28.0575 18.4536 28.3356 15.4575 27.0395C19.3574 22.312 23.2556 17.5878 27.1621 12.8521Z",
    fill: "#141414"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.364 26V10.6H52.304C57.804 10.6 60.994 13.768 60.994 18.212V18.256C60.994 22.7 57.76 26 52.216 26H46.364ZM50.632 22.216H52.37C54.922 22.216 56.616 20.808 56.616 18.322V18.278C56.616 15.814 54.922 14.384 52.37 14.384H50.632V22.216ZM66.9068 26.264C64.6408 26.264 62.9028 24.966 62.9028 22.59V22.546C62.9028 20.082 64.7728 18.806 67.5668 18.806C68.6668 18.806 69.7448 19.026 70.4268 19.268V19.07C70.4268 17.838 69.6568 17.134 68.0508 17.134C66.7968 17.134 65.8288 17.376 64.7728 17.794L63.9148 14.846C65.2568 14.296 66.6868 13.922 68.7328 13.922C70.8668 13.922 72.3188 14.428 73.2648 15.374C74.1668 16.254 74.5408 17.486 74.5408 19.158V26H70.4048V24.768C69.5908 25.67 68.4688 26.264 66.9068 26.264ZM68.4028 23.646C69.6128 23.646 70.4708 22.876 70.4708 21.688V21.138C70.0528 20.962 69.4588 20.83 68.8428 20.83C67.6328 20.83 66.9288 21.424 66.9288 22.304V22.348C66.9288 23.162 67.5448 23.646 68.4028 23.646ZM82.0568 26.264C80.0548 26.264 78.0748 25.692 76.4248 24.504L77.9868 21.974C79.3508 22.876 80.8468 23.338 82.0788 23.338C82.8048 23.338 83.1348 23.118 83.1348 22.7V22.656C83.1348 22.194 82.4748 21.996 81.2208 21.644C78.8668 21.028 76.9968 20.236 76.9968 17.838V17.794C76.9968 15.264 79.0208 13.856 81.7708 13.856C83.5088 13.856 85.3128 14.362 86.6768 15.242L85.2468 17.882C84.0148 17.2 82.6728 16.782 81.7268 16.782C81.0888 16.782 80.7588 17.024 80.7588 17.354V17.398C80.7588 17.86 81.4408 18.08 82.6948 18.454C85.0488 19.114 86.9188 19.928 86.9188 22.238V22.282C86.9188 24.9 84.9608 26.264 82.0568 26.264ZM89.2875 26V9.94H93.4675V15.726C94.2375 14.736 95.3375 13.834 97.0315 13.834C99.5615 13.834 101.08 15.506 101.08 18.212V26H96.8995V19.554C96.8995 18.256 96.2175 17.552 95.2275 17.552C94.2155 17.552 93.4675 18.256 93.4675 19.554V26H89.2875Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_17130_11021",
    x: 0.0229492,
    y: 0,
    width: 37.9536,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17130_11021"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_17130_11021",
    result: "effect2_dropShadow_17130_11021"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_17130_11021",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17130_11021"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.02295,
    y: 2,
    width: 31.9537,
    height: 32,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUcLogoMobile);
export default __webpack_public_path__ + "static/media/uc-logo-mobile.21f59941ca6bc9aa62dafa44b659a871.svg";
export { ForwardRef as ReactComponent };